<template>
    <v-card
        style="background-color: rgba(255,255,255,0); -webkit-box-shadow: 0px 0px 0px 0px rgba(0,0,0,0); box-shadow: 0px 0px 0px 0px rgba(0,0,0,0);"
        class="ml-2 mr-2 pt-0"
    >
        <v-card-actions
            v-if="pendingTrainerWin"
            class="justify-center transparent battle-actions-row"
        >
            <v-btn
                color="amber darken-1 black--text btn-shadow"
                @click="confirmTrainerWin"
            >
                {{ $t('journey.fightButtons.victoryLabel') }} <v-icon>mdi-trophy</v-icon>
            </v-btn>
        </v-card-actions>
        <v-card-actions
            v-else
            class="justify-center transparent battle-actions-row"
        >
            <span
                v-if="showAmbush()"
            >
                <v-card
                    class="pa-2 font-weight-medium red"
                >
                   {{ $t('journey.fightButtons.ambushMessage') }}
                </v-card>
            </span>
            <v-tooltip  v-if="canRun()" top open-delay="350">
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-btn
                            :loading="isLoading"
                            color="error black--text btn-shadow"
                            @click="runTeamRocket"
                        >
                            {{ $t('journey.fightButtons.runLabel') }}
                        </v-btn>
                    </div>
                </template>
                <v-row style="width: 320px !important;">
                    <v-col cols="4">
                        <v-img
                            src='@/assets/pic/web/Meowth_portret.png'
                            width="70"
                            height="70"
                            style="transform: scaleX(-1)"
                        />
                    </v-col>
                    <v-col>
                       {{ $t('journey.fightButtons.runTooltipPrefix') }}{{fight.trainerPokemon.name}}
                    </v-col>
                </v-row>
            </v-tooltip>
            <v-btn
                :loading="isLoading"
                v-if="canEscape() && isNotLeagueFight()"
                color="warning black--text btn-shadow"
                @click="escapeFight"
            >
                {{ $t('journey.fightButtons.escapeLabel') }}
            </v-btn>
            <v-btn
                :loading="isLoading"
                v-if="canLeaveStadion() && isNotLeagueFight()"
                color="blue-grey lighten-4 black--text btn-shadow"
                @click="backToCity"
            >
                {{ positionType === positions.MEWTWO_FIGHT ? $t('journey.fightButtons.leaveLabel') : $t('journey.fightButtons.leaveStadionLabel') }}
            </v-btn>
            <v-btn
                :loading="isLoading"
                v-if="!isNotLeagueFight()"
                color="error lighten-4 black--text btn-shadow"
                @click="surrender"
            >
                {{ $t('journey.fightButtons.surrenderLabel') }}
            </v-btn>
            <v-btn
                :loading="isLoading"
                v-if="canRecallPokemon()"
                color="blue-grey lighten-2 black--text btn-shadow"
                @click="recallPokemon"
            >
                {{ $t('journey.fightButtons.recallLabel') }}
            </v-btn>
            <!-- Druha cesta k PokemonPickerDialog.vue vedle klikaci "choose"
                 dlazdice v gridu (BattleScreen.vue) - viz battle-skills.md. -->
            <v-btn
                :loading="isLoading"
                v-if="canChoosePokemon()"
                color="amber black--text btn-shadow"
                @click="choosePokemon"
            >
                {{ $t('journey.fightButtons.chooseLabel') }}
            </v-btn>
            <div  class="ml-2" v-if="!isTrainerFight && ((!isTrainerFight || !trainerFight.stadionFight) && !canContinueRoad()) && isNotLeagueFight()">
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-if="!canMove(1)"
                            v-bind="attrs" v-on="on"
                        >
                            <v-btn
                                :loading="isLoading"
                                disabled
                                v-if="canGoRound()"
                                color="primary black--text btn-shadow"
                                style="opacity: 1 !important; "
                            >
                                {{ $t('journey.fightButtons.goRoundLabel') }} <span> <v-icon>  mdi-shoe-print </v-icon></span>
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ $t('journey.fightButtons.notEnoughStepsTooltip') }}</span>
                </v-tooltip>
            </div>
            <v-btn
                v-if="canMove(1) && isNotLeagueFight() && !isTrainerFight"
                :loading="isLoading"
                color="primary black--text btn-shadow"
                @click="callMeetPokemon()"
            >
                {{ $t('journey.fightButtons.goRoundLabel') }} <span> <v-icon>  mdi-shoe-print </v-icon></span>
            </v-btn>
            <v-btn
                v-if="!canMove(1) && isNotLeagueFight() && !isTrainerFight"
                :loading="isLoading"
                dark
                color="accent darken-2 black--white btn-shadow"
                @click="campMeetPokemon()"
            >
                {{ $t('journey.fightButtons.campLabel') }} <span>  <v-icon size="18">mdi-moon-waning-crescent</v-icon><v-icon>mdi-shoe-print</v-icon></span>
            </v-btn>
            <v-btn
                v-if="canContinueRoad() && isNotLeagueFight()"
                :loading="isLoading"
                color="primary black--text btn-shadow"
                @click="travel"
                style="opacity: 1;"
            >
                {{ $t('journey.fightButtons.continueLabel') }}
            </v-btn>
            <CatchDialog
                ref="catchDialog"
                v-if="isNotLeagueFight()"
                :fight="fight"
                catch-endpoint="api/catch-pokemon"
                :ball-count="pokeballs"
                ball-icon="mdi-pokeball"
                :can-catch="canCatch()"
            >
                <template #actions>
                    <v-btn
                        :loading="isLoading"
                        v-if="!(fight && fight.winner)"
                        color="warning black--text btn-shadow"
                        @click="escapeFight()"
                    >
                        {{ $t('journey.fightButtons.escapeLabel') }}
                    </v-btn>
                    <v-btn
                        v-if="(!isTrainerFight || !(trainerFight && trainerFight.stadionFight)) && !canContinueRoad()"
                        :loading="isLoading"
                        color="primary black--text btn-shadow"
                        @click="callMeetPokemon()"
                        style="opacity: 1;"
                        :disabled="!canMove(1)"
                    >
                        {{ $t('journey.fightButtons.goRoundLabel') }}
                    </v-btn>
                    <v-btn
                        v-if="canContinueRoad() && !isLoading"
                        :loading="isLoading"
                        color="primary black--text btn-shadow"
                        @click="travel()"
                    >
                        {{ $t('journey.fightButtons.continueOnRoadLabel') }}
                    </v-btn>
                </template>
            </CatchDialog>
        </v-card-actions >
        <ConfirmDialog ref="confirmDialog"/>
    </v-card>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import {Positions} from "@/utils/positionEnum";
    import CatchDialog from '@/components/journey/positions/battle/CatchDialog';
    import ConfirmDialog from '@/components/utils/ConfirmDialog';

    export default {
        components: {CatchDialog, ConfirmDialog},
        props: {
            fight: {Object, default: null},
            trainerFight: {Object, default: null},
            isTrainerFight:  {Boolean, default: false},
            cityId:  {Number, default: false},
            wild: {String, default: null},
            positionType: {String, default: null},
            pokeballs: {Number, default: 0},
        },
        data() {
            return {
                positions: Positions,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
                user: 'user/item',
                steps: 'journey/steps',
                buttonVolume: 'journey/buttonVolume',
                pendingTrainerWin: 'journey/pendingTrainerWin',
            }),
        },
        methods: {
            ...mapActions({
                positionPost: 'journey/positionPost',
                pokemonFight: 'journey/pokemonFight',
                loadPosition: 'journey/loadPosition',
                meetPokemon: 'journey/meetPokemon',
                campPokemon: 'journey/campMeetPokemon',
                trainerInfoMessages: 'trainer/loadInfoMessages',
                refreshActiveTeam: 'pokemon/refreshActiveTeam',
                confirmTrainerWin: 'journey/confirmTrainerWin',
            }),
            resetCatchDialog() {
                if (this.$refs.catchDialog) {
                    this.$refs.catchDialog.reset();
                }
            },
            // Sdileny guard pro Go round/Camp/Leave (backToCity nize) - viz
            // battle-skills.md.
            isStillFighting() {
                return !!(this.fight && this.fight.trainerPokemon
                    && this.fight.trainerPokemon.hp >= 1 && this.fight.winner == null);
            },
            async callMeetPokemon() {
                if (this.isStillFighting()) {
                    let rlyGoRound = await this.$refs.confirmDialog.open(this.$t('journey.fightButtons.confirmGoRound'));
                    if (!rlyGoRound) {
                        return;
                    }
                }
                this.resetCatchDialog();
                const obj = {positionId: this.user.position.id, environment: this.position};
                this.meetPokemon(obj);
            },
            async campMeetPokemon() {
                if (this.isStillFighting()) {
                    let rlyCamp = await this.$refs.confirmDialog.open(this.$t('journey.fightButtons.confirmCamp'));
                    if (!rlyCamp) {
                        return;
                    }
                }
                this.resetCatchDialog();
                const obj = {positionId: this.user.position.id, environment: this.wild};
                this.campPokemon(obj);
            },
            runTeamRocket() {
                const url = new URL("api/run-team-rocket", API_ENTRYPOINT);
                const obj = {url: url, obj:{positionId: this.user.position.id},method:'POST'}
                // Odpoved uz nema aktivni pokemonFight, takze beznej HP-patch
                // mechanismus (trySyncFightingPokemonHp) neodchyti krádež
                // bojujiciho pokemona - plny refetch, at zmizi ze spodni listy.
                this.positionPost(obj).then(() => {
                    this.refreshActiveTeam();
                });
            },
            async backToCity(){
                // Potvrzeni jen kdyz by Leave opustilo jeste nerozhodnuty souboj -
                // po vyhre/prohre je Leave uz jen navrat bez rizika.
                if (this.isStillFighting()){
                    let rlyLeave = await this.$refs.confirmDialog.open(this.$t('journey.fightButtons.confirmLeave'));
                    if (!rlyLeave){
                        return;
                    }
                }
                const url = new URL("api/travel", API_ENTRYPOINT);
                const obj = {url: url, obj:{positionId: this.user.position.id, cityId: this.cityId},method:'POST'}
                this.positionPost(obj);
            },
            async surrender(){
                let rlyDelete = await this.$refs.confirmDialog.open(this.$t('journey.fightButtons.confirmSurrender'));
                if (rlyDelete){
                    const url = new URL("api/surrender-league", API_ENTRYPOINT);
                    const obj = {url: url, obj:{positionId: this.user.position.id, cityId: this.cityId},method:'POST'}
                    this.positionPost(obj);
                }
            },
            async escapeFight(){
                let rlyEscape = await this.$refs.confirmDialog.open(this.$t('journey.fightButtons.confirmEscape'));
                if (rlyEscape){
                    this.resetCatchDialog();
                    const url = new URL("api/escape-fight", API_ENTRYPOINT);
                    const obj = {url: url, obj:{positionId: this.user.position.id},method:'POST'}
                    this.positionPost(obj);
                }
            },
            travel(){
                this.resetCatchDialog();
                const url = new URL("api/travel", API_ENTRYPOINT);
                let freePokemon = 0;
                if (this.fight.winner === true && this.trainerFight && this.trainerFight.teamRocket){
                    freePokemon = this.trainerFight.teamRocket.id;
                }
                const obj = {url: url, obj:{positionId: this.user.position.id, freePokemon: freePokemon},method:'POST'}
                this.positionPost(obj);
            },
            recallPokemon(){
                // Recall neotevira api/recall-pokemon primo - otevre sdileny
                // picker (BattleScreen.vue), vyber noveho pokemona uz sam
                // atomicky prepise trainerPokemon.
                let backgroundSound = require('@/assets/sounds/recall.mp3');
                let sound = new Audio(backgroundSound);
                sound.volume = this.buttonVolume / 100;
                sound.play();
                this.$emit('recall-pokemon');
            },
            choosePokemon(){
                this.$emit('choose-pokemon');
            },
            canChoosePokemon(){
                return !!(this.fight && !this.fight.trainerPokemon);
            },
            canContinueRoad(){
                if (this.positionType === this.positions.LEAGUE_FIGHT){
                    return false;
                }
                if (this.fight && this.fight.trainerPokemon) {
                    if(this.fight.trainerPokemon.hp >= 1 && this.fight.opponentPokemon.hp < 1){
                        if(this.isTrainerFight && this.trainerFight && this.trainerFight.stadionFight){
                            return false;
                        }
                        return true;
                    }else if (this.$refs.catchDialog && this.$refs.catchDialog.catchData && this.$refs.catchDialog.catchData.success){
                        return true;
                    }
                }
                return false;
            },
            canRun(){
                if (this.positionType === this.positions.LEAGUE_FIGHT){
                    return false;
                }
                // trainerPokemon muze byt undefined (ne null) - "!= null" zachyti obe.
                if (this.trainerFight && this.trainerFight.teamRocket && this.fight && !this.fight.winner && this.fight.trainerPokemon != null){
                    return true;
                }
                return false;
            },
            canCatch(){
                if (this.positionType === this.positions.LEAGUE_FIGHT){
                    return false;
                }
               if (this.fight && this.fight.trainerPokemon && !this.isTrainerFight) {
                   if((this.fight.opponentPokemon.hp <= 6 && this.fight.trainerPokemon.hp > 0 )
                       || (this.fight.trainerPokemon.hp < 1 && this.fight.opponentPokemon.hp < 1 )
                   ){
                       return true;
                   }
               }
               return false;
            },
            canRecallPokemon(){
                return !!(this.fight && this.fight.trainerPokemon
                    && this.isTrainerFight
                    && this.trainerFight
                    && this.trainerFight.maxPokemons > this.trainerFight.usedPokemons
                    && this.trainerFight.teamRocket === null);
            },
            canMove(steps) {
                if (this.positionType === this.positions.LEAGUE_FIGHT){
                    return false;
                }
                return steps <= this.steps;
            },
            canGoRound() {
                return !(this.trainerFight && this.trainerFight.teamRocket);
            },
            canEscape() {
                return (!this.isTrainerFight || (this.trainerFight && !this.trainerFight.stadionFight && this.positionType !== this.positions.MEWTWO_FIGHT))
                    && !(this.fight && this.fight.winner)
                    && !(this.trainerFight && this.trainerFight.teamRocket);
            },
            // Mewtwo/Giovanni ma stadionFight=false, ale vstupuje se do nej
            // stejne jako do stadionu primo z CITY - viz battle-skills.md.
            canLeaveStadion() {
               return  this.isTrainerFight && !!(this.trainerFight && (this.trainerFight.stadionFight || this.positionType === this.positions.MEWTWO_FIGHT));
            },
            showAmbush(){
                return (
                       !this.canContinueRoad()
                    && !this.canLeaveStadion()
                    && !this.canEscape()
                    && !this.canMove()
                    && !this.canRun()
                    && !this.canRecallPokemon()
                    && !this.canCatch()
                    && !this.canGoRound()
                    && this.positionType === this.positions.FIGHT_TEAM_ROCKET
                );
            },
            isNotLeagueFight(){
                return this.positionType !== this.positions.LEAGUE_FIGHT;
            },
        },
    }
</script>

<style scoped>
/* Tlacitka nikdy nezalamuji do druheho radku (stejne jako DungeonButtons.vue)
   - misto zalomeni se zmensi padding, at se vejdou na jeden radek i s vice
   tlacitky na mobilni sirku. */
.battle-actions-row {
    flex-wrap: nowrap;
}
.battle-actions-row >>> .v-btn {
    padding: 0 8px;
    min-width: 0;
}
</style>

